/**
 * AWS Cognito Configuration
 * 
 * User Pool ID: us-east-1_3mdtydlsF
 * Client ID: 663puf9ieqabtvfdnlsbuaihqt
 * Region: us-east-1
 */

export const cognitoConfig = {
  region: 'us-east-1',
  userPoolId: 'us-east-1_3mdtydlsF',
  userPoolWebClientId: '663puf9ieqabtvfdnlsbuaihqt',
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  oauth: {
    domain: '',
    scope: ['email', 'openid', 'profile'],
    redirectSignIn: 'http://98.84.152.205:8092/',
    redirectSignOut: 'http://98.84.152.205:8092/',
    responseType: 'code'
  }
};

export const adminEmail = 'dwatkins@aperioglobal.com';
